import { useCallback } from 'react';

const useBrowserStorage = () => {
  const getLocalStorageItem = useCallback((itemName: string) => {
    if (typeof window !== 'undefined') {
      try {
        const localStorageItem = localStorage.getItem(itemName);
        return typeof localStorageItem == 'string'
          ? JSON.parse(localStorageItem)
          : localStorageItem;
      } catch {
        return null;
      }
    }
  }, []);

  const setSessionStorageItem = useCallback(
    (itemName: string, itemValue: string | { [key: string]: string }) => {
      if (typeof window !== 'undefined') {
        try {
          sessionStorage.setItem(itemName, JSON.stringify(itemValue));
        } catch {}
      }
    },
    [],
  );

  const removeSessionStorageItem = useCallback((itemName: string) => {
    if (typeof window !== 'undefined') {
      try {
        sessionStorage.removeItem(itemName);
      } catch {}
    }
  }, []);

  const getSessionStorageItem = useCallback((itemName: string) => {
    if (typeof window !== 'undefined') {
      try {
        const sessionStorageItem = sessionStorage.getItem(itemName);
        return typeof sessionStorageItem == 'string'
          ? JSON.parse(sessionStorageItem)
          : sessionStorageItem;
      } catch {
        return null;
      }
    }
  }, []);

  const setLocalStorageItem = useCallback(
    (itemName: string, itemValue: string | { [key: string]: string }) => {
      if (typeof window !== 'undefined') {
        try {
          localStorage.setItem(itemName, JSON.stringify(itemValue));
        } catch {}
      }
    },
    [],
  );

  const removeLocalStorageItem = useCallback((itemName: string) => {
    if (typeof window !== 'undefined') {
      try {
        localStorage.removeItem(itemName);
      } catch {}
    }
  }, []);

  return {
    getLocalStorageItem,
    setLocalStorageItem,
    removeLocalStorageItem,
    getSessionStorageItem,
    setSessionStorageItem,
    removeSessionStorageItem,
  };
};

export { useBrowserStorage };
